import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { ReceivedTab } from "./ReceivedTab";
import { OutGoingTab } from "./OutGoingTab";
import { GetNewStudentsRequests } from "../../../../api/endpoints/tutors/requests";
import RequestsModel from "../../../../api/models/RequestsModel";
import { ApiResponse } from "../../../../api/apiResponse";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function AppointmentsRequests() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [requests, setRequests] = useState<RequestsModel[]>([]);
  const [oldRequests, setOldRequests] = useState<RequestsModel[]>([]);
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  let { isOutgoingTab } = useParams();
  const tabs = [
    {
      name: t("received"),
      content: (
        <ReceivedTab requests={requestsReceived} oldRequests={oldRequests} />
      ),
      counter: requestsReceived.length,
    },
    {
      name: t("outgoing"),
      content: <OutGoingTab requests={requests} />,
      counter: requests.length,
    },
  ];
  const getRequests = () => {
    makeApiRequest(
      () =>
        GetNewStudentsRequests({
          filters: { sender_type: "Tutor", order_by: "-created_at" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data?.result,
            "sender"
          );

          setRequests(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  const getReceivedRequests = () => {
    makeApiRequest(
      () =>
        GetNewStudentsRequests({
          filters: {
            sender_type: "Student",
            is_new_student: false,
            order_by: "-created_at",
          },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] =
            RequestsModel.fromApiResponsePending(data?.result, "receiver");
          const oldRequests: RequestsModel[] =
            RequestsModel.fromApiResponseWithoutPending(
              data?.result,
              "receiver"
            );
          setRequestsReceived(requestsList);
          setOldRequests(oldRequests);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  useEffect(() => {
    getRequests();
    getReceivedRequests();
  }, []);
  return (
    <div className="flex flex-col w-full bg-gray-50 ">
      <div>
        <h1 className="px-8 mt-2 mb-4 text-2xl font-semibold text-gray-900 ">
          {t("changeAppointments")}
        </h1>
      </div>
      <TabsComponent
        defaultTab={!!isOutgoingTab && isOutgoingTab == "true" ? 1 : 0}
        requests={true}
        tabs={tabs}
      />
    </div>
  );
}
